import { notNothing } from "@/lib/utils/common";

/**
 * Filters out null and undefined values from an array
 */
export function removeNothings<T>(arr: Array<T | null | undefined>): Array<T> {
  return arr.filter(notNothing);
}

/**
 * Converts an array of strings to an array of integers, filtering out any invalid conversions.
 * Only accepts clean integer strings (no decimals or special characters).
 * Particularly useful for transforming string IDs from UI components into numeric IDs for
 * GraphQL queries and mutations.
 *
 * @param strArray - Array of strings to convert to integers
 * @returns Array of successfully parsed integers, excluding invalid values
 *
 * @example
 * // Convert string IDs to numbers for GraphQL input
 * toNumberArray(["14", "15"]) // => [14, 15]
 *
 * // Invalid strings are filtered out
 * toNumberArray(["14", "invalid"]) // => [14]
 * toNumberArray(["1.5", "$100"]) // => []
 */
const INTEGER_PATTERN = /^-?\d+$/;

export function toNumberArray(strArray: string[]): number[] {
  return strArray.filter((str) => INTEGER_PATTERN.test(str.trim())).map((str) => parseInt(str, 10));
}
